import React from 'react';
import { StyledSelect } from '../../styles/styled/Select.styled';

const ComboReusable = (props) => {
  return (
    <StyledSelect
      id={props.id}
      value={props.updateValue}
      onChange={props.onChange}
    >
      <option key="" value="0" selected disabled hidden>
        Izaberite {props.objectName}
      </option>
      {props.items}
    </StyledSelect>
  );
};

export default ComboReusable;
